<div style="background-image: url('../../../../assets/images/login_page_bg.jpg'); background-size: cover;" class="surface-ground flex align-items-center justify-content-center min-h-screen overflow-hidden">
    <div class="flex flex-column align-items-center justify-content-center">
        <div style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%);">
            <p-toast></p-toast>
            <div class="w-full surface-card py-7 px-5 sm:px-8" style="border-radius:53px">
                <div class="text-center mb-5">
                    <img src="../../../../assets/pb_logo.png" alt="logo" class="mb-5 w-7rem flex-shrink-0">
                    <h4 class="text-primary-500"> Login</h4>
                </div>

                <form [formGroup]="form">
                    <div>
                        <label for="email1" class="block mb-1">Email</label>
                        <input id="email1" type="text" formControlName="usr_email_str" placeholder="Email address" pInputText class="lowercase w-full md:w-30rem mb-5 border-1" style="padding:1rem">

                        <label for="pinCount1" class="block  mb-1">PIN</label>
                        <input id="pinCount1" formControlName="pin1" class="pin mx-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                        <input id="pinCount2" formControlName="pin2" class="pin mx-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                        <input id="pinCount3" formControlName="pin3" class="pin mx-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                        <input id="pinCount4" formControlName="pin4" class="pin mx-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                        <input id="pinCount5" formControlName="pin5" class="pin mx-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                        <input (keyup.enter)="login()" id="pinCount6" formControlName="pin6" class="pin mx-1 rounded-xs text-center font-20 font-600" type="tel" maxlength="1" (keydown)="this.utilsService.validatePinNumber($event)"/>
                        <div class="flex align-items-center justify-content-between mt-3">
                            <button (click)="login()" pButton pRipple label="Login" class="w-full p-3 text-xl" [disabled]="form.invalid"></button>
                        </div>                    </div>
                    <p-progressSpinner *ngIf="loading.form" styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="flex justify-content-center">
    <p-dialog
        header="Privacy Policy"
        [modal]="true"
        [(visible)]="visible"
        [appendTo]="'body'"
        [style]="{ width: '60rem' }"
        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
        [maximizable]="true">

        <div class="container mt-3 p-2">
            <div class="row">
                ABC Pvt. Ltd. is delighted that you have visited our website and thanks you for your interest in our company.
                <br>
                <br>
                ABC Pvt. Ltd. takes data protection seriously. This Privacy Statement describes:
                <br>
                - The personal data ABC Pvt. Ltd. collects when you visit our website <br>
                - The purposes for which ABC Pvt. Ltd. uses such data<br>
                - The legal basis for the processing of personal data<br>
                - The recipients of such personal data<br>
                - The period for which such personal data will be stored<br>
                - whether you are obliged to provide personal data<br>
                <br>
                <br>
                Furthermore, we would like to inform you about:
                <br>
                - The existence of your rights regarding the processing of your personal data<br>
                - The Controller in the meaning of data protection laws and, where applicable, our Data Protection Officer<br>
            </div>
        </div>
    </p-dialog>
    <p-dialog
        header="Terms of Service"
        [modal]="true"
        [(visible)]="visibleTC"
        [appendTo]="'body'"
        [style]="{ width: '60rem' }"
        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
        [maximizable]="true">

        <div class="container mt-3 p-2">
            <div class="row">
                ABC Pvt. Ltd. is delighted that you have visited our website and thanks you for your interest in our company.
                <br>
                <br>
                ABC Pvt. Ltd. takes data protection seriously. This Privacy Statement describes:
                <br>
                - The personal data ABC Pvt. Ltd. collects when you visit our website <br>
                - The purposes for which ABC Pvt. Ltd. uses such data<br>
                - The legal basis for the processing of personal data<br>
                - The recipients of such personal data<br>
                - The period for which such personal data will be stored<br>
                - whether you are obliged to provide personal data<br>
                <br>
                <br>
                Furthermore, we would like to inform you about:
                <br>
                - The existence of your rights regarding the processing of your personal data<br>
                - The Controller in the meaning of data protection laws and, where applicable, our Data Protection Officer<br>
            </div>
        </div>
    </p-dialog>
</div>
